import styled, { css } from 'styled-components';
import { Media } from '../../../theme/Media';
import { Section } from '../../Components/Section';
export const StandaloneSubmitSectionWrapper = styled(Section) `
  padding: 16px 12px;

  @media ${Media.mdMin} {
    margin-top: 24px;
  }

  @media ${Media.smMax} {
    margin-top: 8px;
  }
`;
export const standaloneSubmitSectionItemsStyles = css `
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
